import { useState } from 'react';
import { GAME, dateLabel, START_DAY, END_DAY, INVITE_PARAM } from '../utils/christmasGame';

/* Две неща, които връщат хората всеки ден и водят нови:
   1. „Напомни ми всеки ден“ — файл за календара (.ics) със събитие всеки ден
      в 19:00 до края на играта. На телефона се отваря направо в календара.
   2. „Покани приятелка“ — менюто за споделяне на телефона (Viber, Messenger,
      WhatsApp…), а на компютър — Facebook, Viber и копиране на линка.
      Влезлият участник споделя личен линк (?pokana=<uid>) и получава билети,
      когато поканената завърти за първи път (ChristmasGame.js).
   Напомнянето е без сървър и без имейл списък — всичко става в браузъра. */

const PAGE_URL = `https://stamsyart.bg${GAME.path}`;

const SHARE_TEXT =
  `Всеки ден от ${dateLabel(START_DAY)} до ${dateLabel(END_DAY)} завъртам коледното колело ` +
  'на Stamsy Art – печели се отстъпка, безплатна доставка или подарък 🎄';

const compact = iso => iso.replace(/-/g, '');

/* Часът е „плаващ“ (без часова зона) — 19:00 по часовника на телефона,
   и след смяната на лятното време. */
function calendarFile() {
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Stamsy Art//Koledno kolelo//BG',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `UID:koledno-kolelo-${compact(GAME.start)}@stamsyart.bg`,
    `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '')}`,
    `DTSTART:${compact(GAME.start)}T190000`,
    `DTEND:${compact(GAME.start)}T191000`,
    `RRULE:FREQ=DAILY;UNTIL=${compact(GAME.end)}T235959`,
    'SUMMARY:🎄 Завърти коледното колело на Stamsy Art',
    `DESCRIPTION:Едно завъртане на ден – отстъпка\\, безплатна доставка или подарък. ${PAGE_URL}`,
    `URL:${PAGE_URL}`,
    'BEGIN:VALARM',
    'TRIGGER:PT0M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Време е да завъртиш коледното колело 🎄',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ];
  return new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
}

function addReminder() {
  const url = URL.createObjectURL(calendarFile());
  const a = document.createElement('a');
  a.href = url;
  a.download = 'koledno-kolelo-napomnyane.ics';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const ChristmasInvite = ({ uid, invited = 0 }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = uid ? `${PAGE_URL}?${INVITE_PARAM}=${uid}` : PAGE_URL;
  const left = Math.max(0, GAME.maxInvites - invited);
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  const nativeShare = () =>
    navigator.share({ title: GAME.h1, text: SHARE_TEXT, url: shareUrl }).catch(() => {});

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(`${SHARE_TEXT} ${shareUrl}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      window.prompt('Копирай линка:', shareUrl);
    }
  };

  const enc = encodeURIComponent;

  return (
    <div className="xg-card xg-invite">
      <span className="xg-eyebrow">Не пропускай нито ден</span>
      <p className="xg-invite-lead">
        Всеки ден е ново завъртане и нов билет за голямата награда.
      </p>
      <button type="button" className="xg-btn xg-invite-remind" onClick={addReminder}>
        🔔 Напомни ми всеки ден в 19:00
      </button>

      <span className="xg-eyebrow xg-invite-eyebrow">Покани приятелка</span>
      <p className="xg-invite-lead">
        {!uid
          ? `Влез в профила си, за да получиш личен линк – за всяка приятелка, която завърти за първи път по него, печелиш още ${GAME.ticketsPerInvite} билета.`
          : left > 0
            ? `За всяка приятелка, която завърти за първи път по твоя линк, получаваш още ${GAME.ticketsPerInvite} билета (до ${GAME.maxInvites} приятелки).`
            : `Събра билетите за всички ${GAME.maxInvites} покани. Благодарим! 💛`}
      </p>
      <div className="xg-invite-share">
        {canNativeShare && (
          <button type="button" className="xg-btn" onClick={nativeShare}>Сподели</button>
        )}
        <a
          className="xg-btn xg-btn-ghost"
          href={`https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </a>
        <a className="xg-btn xg-btn-ghost" href={`viber://forward?text=${enc(`${SHARE_TEXT} ${shareUrl}`)}`}>
          Viber
        </a>
        <button type="button" className="xg-btn xg-btn-ghost" onClick={copyLink} aria-live="polite">
          {copied ? 'Копирано ✓' : 'Копирай линка'}
        </button>
      </div>
    </div>
  );
};
